import React from "react";
import { motion } from "framer-motion";

export default function AboutBanner() {
    // Make sure your image is placed here:
    // public/assets/images/backgrounds/about-banner.png
    const publicUrl = process.env.PUBLIC_URL;

    return (
        <section className="w-full h-[70vh] md:h-[85vh] relative overflow-hidden flex items-center justify-center">
            {/* Clean Image using <img> tag - Always Works */}
            <img
                src={`${publicUrl}/assets/images/backgrounds/about-banner.png`}
                alt="Nazar Enterprise & Co. - Marine & Industrial Suppliers"
                style={{width: "100%" , maxHeight: "720px"}}
                className="absolute inset-0 w-full h-full object-cover object-center -z-10"
            />

            {/* Optional: Very light overlay only if text is hard to read */}
            {/* Remove this line completely if you want zero overlay */}
            <div className="absolute inset-0 bg-black/20"></div>

            {/* Content on Top */}
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="relative z-10 text-center px-6 max-w-5xl"
            >
                <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold drop-shadow-2xl leading-tight">
                    Nazar Enterprise & Co.
                </h1>
                <p className="text-white text-lg md:text-xl lg:text-2xl mt-6 font-medium drop-shadow-lg">
                    Suppliers of Marine & Industrial Machinery,<br className="hidden md:block" />
                    Automation Systems, Navigation Units & Electronic Equipment
                </p>
            </motion.div>
        </section>
    );
}